"use server";
// РУКА 2. Данные для корзины: актуальные товары и комплекты по тому, что лежит в корзине, и проверка промокода.
// Всё берём у Руки 3 по договору; в корзине браузера хранятся только id и количество.
import type { KitView, ProductView } from "@/contract";
import { ruka3 } from "@/ruka3";

const MAX = 100; // больше позиций в корзине не бывает — защита от мусора

export async function loadCart(
  productIds: string[],
  kitSlugs: string[],
): Promise<{ products: Record<string, ProductView | null>; kits: Record<string, KitView | null> }> {
  const ids = [...new Set(productIds)].slice(0, MAX);
  const slugs = [...new Set(kitSlugs)].slice(0, MAX);
  const [products, kits] = await Promise.all([
    Promise.all(ids.map((id) => ruka3.getProduct(id))),
    Promise.all(slugs.map((s) => ruka3.getKit(s))),
  ]);
  return {
    products: Object.fromEntries(ids.map((id, i) => [id, products[i]])),
    kits: Object.fromEntries(slugs.map((s, i) => [s, kits[i]])),
  };
}

export async function checkPromo(code: string, total: number) {
  const c = code.trim().slice(0, 32);
  if (!c || !(total > 0)) return { ok: false, discount: 0, reason: "Промокод не найден" };
  return ruka3.applyPromo(c, total);
}
